<template>
  <aside :class="{'closed':sidebarClosed}" v-if="user != null">
    <header :class="{ 'opened': headerOpened || $route.path.indexOf('/informacoes-pessoais') > -1 }">
      <div class="userInfo" @click="toggleHeader">
        <img :src="photo" width="40" height="40" :alt="user.name" />
        <p class="userData">{{ user.name }}</p>
        <div class="clearfix"></div>
      </div>

      <button class="closeBtn" @click="toggleSidebar">
        <i class="far fa-angle-left"></i>
      </button>

      <div class="clearfix"></div>

      <ul class="headerDropdown">
        <router-link tag="li" :class="{ 'active': $route.path.indexOf('/informacoes-pessoais') > -1}" to="/informacoes-pessoais" class="item"><i class="far fa-user-circle" v-tooltip="(sidebarClosed)?'Informações Pessoais':''"></i> Informações Pessoais</router-link>
        <li class="item" @click="logout"><i class="far fa-sign-out" v-tooltip="(sidebarClosed)?'Sair':''"></i> Sair</li>
      </ul>

      <div class="clearfix"></div>
    </header>

    <div class="box">
      <p class="title">{{(sidebarClosed)?'ADM':'ADMINISTRADOR'}}</p>

        <router-link tag="li" exact-active-class="active" to="/" class="item"><i class="far fa-tachometer-alt" v-tooltip="(sidebarClosed)?'Dashboard':''"></i> Dashboard</router-link>
        <router-link tag="li" :class="{ 'active': $route.path.indexOf('/clientes') > -1}" to="/clientes" class="item"><i class="far fa-users" v-tooltip="(sidebarClosed)?'Clientes':''"></i> Clientes</router-link>
        <router-link tag="li" :class="{ 'active': $route.path.indexOf('/transacoes') > -1}" to="/transacoes" class="item"><i class="far fa-chart-bar" v-tooltip="(sidebarClosed)?'Transações':''"></i> Transações</router-link>
        <router-link tag="li" :class="{ 'active': $route.path.indexOf('/contas-de-whatsapp') > -1}" to="/contas-de-whatsapp" class="item"><i class="fab fa-whatsapp" v-tooltip="(sidebarClosed)?'Contas de Whatsapp':''"></i> Contas de Whatsapp</router-link>

      <router-link tag="li" :class="{ 'active': $route.path.indexOf('/afiliados') > -1}" to="/afiliados" class="item"><i class="far fa-share-alt" v-tooltip="(sidebarClosed)?'Afiliados':''"></i> Afiliados</router-link>
      <router-link tag="li" :class="{ 'active': $route.path.indexOf('/indicacoes') > -1}" to="/indicacoes" class="item"><i class="far fa-users" v-tooltip="(sidebarClosed)?'Indicações':''"></i> Indicações</router-link>
      <router-link tag="li" :class="{ 'active': $route.path.indexOf('/tipos-de-lembrete') > -1}" to="/tipos-de-lembrete" class="item"><i class="fas fa-tags" v-tooltip="(sidebarClosed)?'Tipos de Lembrete':''"></i> Tipos de Lembrete</router-link>
      <router-link tag="li" :class="{ 'active': $route.path.indexOf('/unidades') > -1}" to="/unidades" class="item"><i class="far fa-hospital" v-tooltip="(sidebarClosed)?'Unidades':''"></i> Unidades</router-link>
    </div>

    <p class="logo">
      <img src="@/assets/images/consulta-ja-logo.svg" width="50%" alt="Consulta Já" class="mb-0" /><br/>
      <small>{{ version }}</small>
    </p>
  </aside>
</template>

<script>
export default {
  name: 'Sidebar',
  data() {
    return {
      sidebarClosed: false,
      headerOpened: false,
      userNameInitials: '',
      affiliatesOpened: false,
      photo: '',

      user: JSON.parse(localStorage.getItem('user')),
      version: process.env.VUE_APP_VERSION
    }
  },
  watch: {
    '$route' () {
      if(this.$attrs['isMobile'] && this.sidebarClosed) {
        this.toggleSidebar();
      }
    }
  },
  mounted() {
    setTimeout(() => {
      this.user = JSON.parse(localStorage.getItem('user'));
      this.version = localStorage.getItem('version');

      // let userData = this.user;
      // this.sentry.configureScope(function(scope) {
      //   scope.setUser({
      //     'id': userData.person.id,
      //     'email': userData.person.email,
      //     'Name': userData.person.name,
      //     'Client ID': userData.person.client.id,
      //     'Client Name': userData.person.client.name,
      //   });
      // });

      // if(process.env.VUE_APP_ENVIRONMENT == 'production') {
      //   this.$ma.setUserProperties({
      //     userId: userData.person.id,
      //     name: userData.person.name,
      //     email: userData.person.email
      //   });
      // }
      this.photo = this.user.person.photo ? this.user.person.photo : ('https://via.placeholder.com/40x40/eaf1f4/11a6f3?text=' + this.userNameInitials);

      this.eventBus.$on('USER_PHOTO_CHANGED', (photo) => {
        this.photo = photo ? photo : ('https://via.placeholder.com/40x40/eaf1f4/11a6f3?text=' + this.userNameInitials);
        let user = JSON.parse(localStorage.getItem('user'));
        user.person.photo = photo;
        localStorage.setItem('user', JSON.stringify(user));
      });
    }, 500);
  },
  methods: {
    toggleSidebar() {
      this.sidebarClosed = !this.sidebarClosed;
    },
    toggleHeader() {
      this.headerOpened = !this.headerOpened;
    },
    logout() {
      this.$swal({
        title: 'Você tem certeza de que deseja sair?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sair',
        cancelButtonText: 'Cancelar',
        dangerMode: true
      }).then((res) => {
        if(res.value) {
          localStorage.clear();
          this.eventBus.$emit('IS_LOGGED', false);
          this.$router.push('/login');
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
  aside {
    font-family: 'sf_pro_displaymedium';
    width: 280px;
    background-color: $bunting;
    overflow: hidden;
    transition: all 0.5s;
    display: flex;
    flex-flow: column wrap;

    * {
      transition: all 0.5s;
    }

    header {
      background-color: $tangaroa;
      position: relative;
      overflow: hidden;
      max-height: 90px;
      height: 90px;
      flex: 1;
      width: 100%;

      .userInfo {
        width: 280px;
        padding: 25px;
        cursor: pointer;
        display: inline-block;

        * {
          cursor: pointer;
        }

        img {
          border: 2px solid $blueBayoux;
          border-radius: 5px;
          float: left;
        }

        .userData {
          width: 175px;
          color: $athenGray2;
          font-family: 'sf_pro_displaybold';
          margin: 0 0 0 15px;
          line-height: 20px;
          float: left;
          cursor: pointer;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .closeBtn {
        height: 40px;
        background-color: $waikawaGray;
        border: 0;
        border-radius: 5px 0 0 5px;
        cursor: pointer;
        position: absolute;
        right: 0;
        top: 25px;
        transition: all 0.5s;

        i {
          font-size: 17px;
          color: $linkWater;
          vertical-align: middle;
          transition: all 0.5s;
          cursor: pointer;
        }
      }

      .headerDropdown {
        width: 280px;
        max-height: 0;

        .item.active {
          border-color: transparent;
        }
      }

      ul {
        margin: 0;
      }

      &.opened {
        max-height: 200px;
        padding-bottom: 25px;

        .headerDropdown {
          max-height: 200px;
        }
      }
    }

    .item {
      width: 280px;
      padding: 8px 25px 8px 21px;
      display: flex;
      align-items: center;
      color: $cadetGray;
      border-left: 4px solid transparent;
      cursor: pointer;

      i {
        width: 20px;
        text-align: center;
        font-size: 20px;
        margin-right: 15px;
      }

      &.active {
        color: $athenGray2;
        font-family: 'sf_pro_displaybold';

        i {
          color: #24A7F0;
        }
      }

      &:hover {
        color: $athenGray2;
        font-family: 'sf_pro_displaybold';

        i {
          color: #24A7F0;
        }
      }
    }

    .box {
      width: 100%;
      flex: 1;
      margin-top: 25px;

      .title {
        margin: 5px 25px 5px 25px;
        font-size: 12px;
        font-weight: bold;
        color: $waikawaGray;
      }

      .has-dropdown {
        overflow: hidden;
        display: flex;
        flex-flow: row wrap;
        border-left: 4px solid transparent;

        .item {
          border: 0;
        }

        > .item:first-child {
          position: relative;

          &:before {
            width: 12px;
            height: 12px;
            font-family: 'Font Awesome 5 Pro';
            font-weight: 400;
            content: '\f107';
            position: absolute;
            right: 25px;
            top: 50%;
            transform: translateY(-50%);
            transition: all 0.5s;
          }
        }

        .dropdown {
          max-height: 0;
        }

        &.opened {
          margin: 5px 0;
          padding: 5px 0;
          background-color: $tangaroa;
          border-left: 4px solid $pictionBlue;

          > .item:first-child {
            color: $athenGray2;
            font-family: 'sf_pro_displaybold';

            i {
              color: $pictionBlue;
            }

            &:before {
              transform: scaleY(-1);
            }
          }

          .dropdown {
            max-height: 200px;
          }
        }
      }
    }

    .logo {
      text-align: right;
      margin: 25px 15px;
      align-self: flex-end;
      position: relative;

      small {
        font-size: 50%;
        line-height: 0.5;
        color: $whisper;
        position: absolute;
        top: 2px;
        right: 20px;
        text-align: left;
      }
    }

    &.closed {
      width: 90px;

      header {
        .closeBtn {
          i {
            transform: scaleX(-1);
          }
        }
      }

      .item {
        i {
          width: 40px;
          margin-right: 25px;
        }
      }

      .attendance {
        max-height: 0;
        padding: 0;
      }

      .box {
        .title {
          width: 40px;
          text-align: center;
        }
      }

      .logo {
        transform: scaleX(0);
      }
    }
  }

  @media (max-width: 767px) {
    aside {
      width: 100%;
      position: fixed;
      top: 0;
      left: 0;
      min-height: 96px;
      max-height: 96px;
      z-index: 100;
      overflow: hidden;

      .item {
        width: 100%;
      }

      .closeBtn {
        i {
          transform: rotate(-90deg);
        }
      }

      &.closed {
        width: 100%;
        min-height: 100vh;
        max-height: 100vh;
        display: -webkit-box;
        flex-flow: column;

        header {
          .closeBtn {
            i {
              transform: rotate(90deg);
            }
          }

          &.opened {
            flex: 0;
            max-height: none;
            height: auto;

            .headerDropdown {
              max-height: none;
              width: 100%;
            }
          }
        }

        .item {
          i {
            width: 20px;
            margin-right: 15px;
          }
        }

        .box {
          overflow: hidden;
          overflow-y: scroll;

          .title {
            width: auto;
            text-align: left;
          }
        }

        .logo {
          transform: scaleX(1);

          img {
            max-width: 120px;
          }
        }

      }
    }
  }
</style>
